/*eslint complexity: off*/
import React from 'react';
import PropTypes from 'prop-types';

import GridContainer from '~/components/GridContainer';
import GridItem from '~/components/GridItem';
import MedicalRecordRecord from '~/records/MedicalRecordRecord';
import InputShow from '~/components/InputShow';

import { maritalStatusOptions } from '~/config/constants';

const attrName = (attr) => MedicalRecordRecord.hummanAttributeName(attr);

function MedicalRecordShow({ record }) {
  return (
    <>
      <GridContainer>
        <GridItem xs={12} sm={6} md={6} lg={6} xl={6}>
          <InputShow
            value={record.get('doctor')}
            digObject={['name']}
            type={'object'}
            label={attrName('doctor')}
          />
        </GridItem>

        <GridItem xs={12} sm={6} md={6} lg={6} xl={6}>
          <InputShow
            label={attrName('religion')}
            value={record.get('religion')}
          />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <InputShow
            label={attrName('health_insurance')}
            value={record.get('health_insurance')}
          />
        </GridItem>
        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <InputShow
            label={attrName('medical_plan')}
            value={record.get('medical_plan')}
          />
        </GridItem>
        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <InputShow
            label={attrName('medical_number')}
            value={record.get('medical_number')}
          />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={2} md={2} lg={2} xl={2}>
          <InputShow
            type="float"
            label={attrName('weight')}
            value={record.get('weight')}
          />
        </GridItem>
        <GridItem xs={12} sm={2} md={2} lg={2} xl={2}>
          <InputShow
            type="float"
            label={attrName('height')}
            value={record.get('height')}
          />
        </GridItem>

        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <InputShow label={attrName('rg')} value={record.get('rg')} />
        </GridItem>

        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <InputShow
            label={attrName('profession')}
            value={record.get('profession')}
          />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <InputShow
            label={attrName('father_name')}
            value={record.get('father_name')}
          />
        </GridItem>

        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <InputShow
            label={attrName('mother_name')}
            value={record.get('mother_name')}
          />
        </GridItem>

        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <InputShow
            label={attrName('kinship')}
            value={record.get('kinship')}
          />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <InputShow
            label={attrName('family_contact')}
            value={record.get('family_contact')}
          />
        </GridItem>

        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <InputShow
            value={record.get('naturalness')}
            digObject={['name']}
            type={'object'}
            label={attrName('naturalness')}
          />
        </GridItem>

        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <InputShow
            label={attrName('marital_status')}
            value={maritalStatusOptions[record.get('marital_status')]}
          />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12} xl={12}>
          <InputShow
            label={attrName('medication_in_use')}
            value={record.get('medication_in_use')}
          />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12} xl={12}>
          <InputShow
            multiline={true}
            label={attrName('additional_information')}
            value={record.get('additional_information')}
          />
        </GridItem>
      </GridContainer>
    </>
  );
}

MedicalRecordShow.propTypes = {
  record: PropTypes.instanceOf(MedicalRecordRecord).isRequired,
};

export default React.memo(MedicalRecordShow);
